<template>
  <KTCard data-cy="referral-add-page">
    <ReferralForm ref="referralForm" :regions="regions" :referralOptions="referralOptions" @submitForm="onSubmitForm" />

    <template v-slot:footer>
      <div class="d-flex justify-content-start">
        <ButtonElement
          data-cy="submit-btn"
          variant="primary"
          text="save"
          class="mr-3"
          @click="onClickSubmit"
        />

        <ButtonElement data-cy="back-btn" variant="text-primary" text="back" @click="onClickBack" />
      </div>
    </template>
  </KTCard>
</template>

<script>
import { mapActions } from "vuex";
import storage from "@/services/storage.service";
import apolloMixin from "@/mixins/apollo.mixin";
import { requiredData } from "./gql/queries";
import KTCard from "@/components/card/KTCard";
import ReferralForm from "../_components/ReferralForm";
import ButtonElement from "@/components/ButtonElement";

const CONTENT_WIDTH = 700;

export default {
  name: "ReferralAdd",
  components: {
    KTCard,
    ReferralForm,
    ButtonElement,
  },

  mixins: [apolloMixin],

  data: () => ({
    regions: [],
    referralOptions: {},
  }),

  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },

  async created() {
    await this.getRequiredData();
  },

  mounted() {
    this.$setBreadcrumbs(["ReferralList"]);
    this.$setMaxContentWidth(CONTENT_WIDTH);
  },

  beforeDestroy() {
    this.$resetMaxContentWidth();
  },

  methods: {
    ...mapActions("publicReferral", ["createReferral"]),

    async getRequiredData() {
      const { regions, referralOptions } = await this.$get(requiredData);

      // TODO: fix when will be country switch
      // this.regions = regions.map((region) => ({ ...region, name: region.name[this.locale] }));
      this.regions = regions.map((region) => ({ ...region, name: region.name["ua"] }));
      this.referralOptions = referralOptions;
    },

    onClickSubmit() {
      this.$refs.referralForm.submitForm();
    },

    async onSubmitForm(referralData) {
      const response = await this.createReferral(referralData);

      storage.setObj("notify", { type: "success", message: response.data.message });

      await this.$router.push({ name: "ReferralList" });
    },

    onClickBack() {
      this.$router.push({ name: "ReferralList" });
    },
  },
};
</script>
